import { Ref } from 'react'

import { OperationRoomIcon } from '../../icons/OperationRoomIcon'
import { SizeOptions } from '../../types/types'
import { AstraEntityChip, EntityChipSize, EntityChipVariant } from '../AstraEntityChip/AstraEntityChip'

const OR_CHROMA = 20
const OR_LUMINANCE = 70

type Props = {
    /**
     * Short name or identifier to display (e.g., "OR1", "OR2")
     */
    shortName: string
    /**
     * Full name for tooltip (optional)
     */
    fullName?: string
    /**
     * Visual variant of the chip
     */
    variant?: EntityChipVariant
    /**
     * Size of the chip
     */
    size?: SizeOptions
    /**
     * data-testid for testing purposes
     */
    'data-test'?: string
    /**
     * Ref to the div element
     */
    ref?: Ref<HTMLDivElement>
    /**
     * Optional title attribute to override the default tooltip text (defaults to fullName ?? shortName)
     * Set to null to hide the tooltip
     */
    title?: string | null
}

/**
 * AstraOperationRoomChip displays a colored chip with operation room information.
 * The color is automatically generated based on the shortName using a desaturated LCH profile
 * suited for room/location entities.
 */
export const AstraLocationChip = ({ ref, shortName, fullName, variant = 'primary', size = 'small', 'data-test': dataTest = 'location-chip', title }: Props) => {
    const entitySize: EntityChipSize = size === 'large' ? 'medium' : size
    const titleValue = title !== null ? (title ?? fullName ?? shortName) : undefined

    return (
        <AstraEntityChip
            ref={ref}
            icon={OperationRoomIcon}
            label={shortName}
            size={entitySize}
            variant={variant}
            chroma={OR_CHROMA}
            luminance={OR_LUMINANCE}
            avalanche
            data-test={dataTest}
            title={titleValue}
        />
    )
}
